(ns app.front.view.licence.subs
  (:require [app.domain.group.model :as group-model]
            [app.front.entities :as entities]
            [app.front.process :as process]
            [app.front.view.workspace.primary-actions :as primary-actions]
            [app.i18n.model :as i18n-model]
            [core.front.event :refer [<sub]]
            [core.front.href :as href]
            [core.util.util :as util]
            [re-frame.core-instrumented :as rf]))

(rf/reg-event-fx ::fetch-licence
  (fn [{:keys [db]} [_ group-id licence-id]]
    {:db           (assoc db ::state {})
     :comm/command {:command    :licence/get
                    :method     :get
                    :data       (util/mmap group-id licence-id)
                    :on-success [::fetch-licence.success group-id licence-id]}}))

(rf/reg-event-fx ::fetch-licence.success
  (fn [{:keys [db]} [_ group-id licence-id status {:keys [entities unfinished-import-session-id]}]]
    (let [licence      (->> entities
                            vals
                            (filter #(and (-> % :domain/authority-group entities :group/id (= group-id))
                                          (= (:licence/id %) licence-id)))
                            first)
          process-flow (-> licence :licence/category-group-config entities :group.config/process-flow)
          country      (-> licence :licence/municipality entities :municipality/country)]
      {:db (-> (assoc-in db [::state :licence-id] (:db/id licence))
               (assoc-in [::state :unfinished-import-session-id] unfinished-import-session-id))
       :fx [[:dispatch [::entities/merge-entity-db status entities]]
            [:dispatch [::process/fetch-process-states-for-one
                        :entity.type/licence
                        country
                        :permit-type/L
                        process-flow]]]})))

(rf/reg-sub ::state :-> ::state)

(rf/reg-sub ::licence-entity-id
  :<- [::state]
  :-> :licence-id)

(rf/reg-sub ::licence
  :<- [::entities/context]
  :<- [::licence-entity-id]
  (fn [[ctx licence-id] _]
    (entities/find-entity ctx licence-id)))

(rf/reg-sub ::municipality
  :<- [::licence]
  :-> :licence/municipality)

(rf/reg-sub ::country
  :<- [::municipality]
  :-> :municipality/country)

(rf/reg-sub ::process-flow
  :<- [::licence]
  (fn [licence _]
    ;; licences only have category
    (-> licence :licence/category-group-config :group.config/process-flow)))

(rf/reg-sub ::current-licence-process
  :<- [::country]
  :<- [::process-flow]
  :<- [::licence-entity-id]
  (fn [[country process-flow licence-id] _]
    (<sub [::process/generic-entity-process
           country
           :permit-type/L
           process-flow
           licence-id])))

(rf/reg-sub ::current-workspaces
  :<- [::licence]
  (fn [licence _]
    (->> licence
         :licence/workspaces
         (remove nil?)
         (sort-by :entity/created)
         reverse)))

(rf/reg-sub ::authority-group
  :<- [::licence]
  :-> :domain/authority-group)

(rf/reg-sub ::tr-replacements
  :<- [::authority-group]
  (fn [authority-group _]
    (merge (group-model/get-i18n-mapping authority-group)
           (i18n-model/permit-type-specific-keys :permit-type/L))))

(rf/reg-sub ::tr
  :<- [::tr-replacements]
  :<- [:tr]
  (fn [[replacements tr] _]
    (i18n-model/wrap-tr-fn replacements tr)))

(rf/reg-sub ::issued-to
  (fn [[_ licence-id]]
    (rf/subscribe [::licence licence-id]))
  (fn [licence _]
    (-> licence :licence/issued-to)))

(rf/reg-sub ::authority-group-id
  :<- [::authority-group]
  :-> :db/id)

(rf/reg-sub ::unfinished-import-session-id
  :<- [::state]
  :-> :unfinished-import-session-id)

(rf/reg-sub ::import-session-href
  :<- [::authority-group-id]
  :<- [::unfinished-import-session-id]
  (fn [[group-id session-id] _]
    (when session-id
      (href/href :view/group.admin.import.session
                 (util/mmap group-id session-id)))))


(rf/reg-sub ::view-data
  :<- [::import-session-href]
  :<- [::licence-options]
  (fn [[import-session-href options] _]
    {:back-href (or import-session-href
                    (href/href :dashboard))
     :options   options}))


(rf/reg-sub ::licence-options
  :<- [::tr]
  (fn [tr _]
    (let [process        (<sub [::current-licence-process])
          process-target (<sub [::licence])]
      {:items (->> (primary-actions/secondary-actions (util/mmap tr process process-target))
                   (map (partial primary-actions/signal->action tr process-target)))})))
